import { useCallback, useMemo } from "react";
import { parsePrice, formatNumberCustom } from "../../../utils/getPrice";
var useFunctions = function () {
    var filterData = useCallback(function (array, key, value) {
        var temp = array.filter(function (e) { return e[key] === value; });
        return temp.map(function (item) { return ({
            id: item.id,
            value: item.id,
            name: item.description,
        }); });
    }, []); // No dependencies
    // Helper function to parse and format price
    var getFormattedPrice = function (priceData) {
        var price = parsePrice(priceData || 0);
        return formatNumberCustom(price || 0);
    };
    var mapDataToSelect = function (data, idField, nameField) {
        if (idField === void 0) { idField = 'id'; }
        if (nameField === void 0) { nameField = 'description'; }
        return data.map(function (item) { return ({
            id: item[idField],
            value: item[idField],
            name: item[nameField] || '',
        }); });
    };
    var filterAndSetData = function (data, type, setState) {
        var result = filterData(data, "type", type);
        if (result.length > 0) {
            setState(result);
        }
    };
    return useMemo(function () { return ({
        filterData: filterData,
        getFormattedPrice: getFormattedPrice,
        mapDataToSelect: mapDataToSelect,
        filterAndSetData: filterAndSetData
    }); }, [
        filterData,
        getFormattedPrice,
        mapDataToSelect,
        filterAndSetData
    ]);
};
export default useFunctions;
